"use strict";

const siteWrapSelector = '.site_wrap';
const headerMobileNavEl = '.header_mobile__nav';

/**
 * This function is triggered on initial load and resize.
 * Toggles mobile main menu only if wrap element is present and if mobile main menu is not hidden
 * on article.
 * In that case if platform is `Mobile`, shows mobile main menu, otherwise, it gets hidden.
 */
function toggleMobileMainMenu() {
  const siteWrapElement = document.querySelector(siteWrapSelector);
  const navElement = document.querySelector(headerMobileNavEl);
  const isMobile = window.getPlatform() === 'Mobile';
  if (!siteWrapElement || !navElement || navElement.classList.contains('hidden_on_page')) return;
  navElement.classList.toggle('hidden', !isMobile);
}
;

// On resize end, check menu mode
window.addEventListener('resize', window.debounce(() => {
  toggleMobileMainMenu();
}, 300));

// Collapse navigation on scroll
let prevScrollPosition = window.pageYOffset;
window.addEventListener('scroll', () => {
  const currentScrollPosition = window.pageYOffset;
  const htmlElement = window.document.getElementsByTagName('html')[0];

  // Collapse navigation after 276px
  if (htmlElement && window.pageYOffset > 276) {
    htmlElement.classList.toggle('has-collapsed-navigation', prevScrollPosition <= currentScrollPosition);
  }
  prevScrollPosition = currentScrollPosition;
}, {
  passive: true
});
document.addEventListener('DOMContentLoaded', () => {
  const navElement = document.querySelector(headerMobileNavEl);
  const navListElement = navElement.querySelector('.header_mobile__nav_list');
  const siteWrapElement = document.querySelector(siteWrapSelector);
  const isMobile = window.getPlatform() === 'Mobile';
  if (!navElement || !navListElement) return;

  // On initial load, if platform is Mobile call method for check of menu mode
  if (isMobile) toggleMobileMainMenu();
  let isDown = false;
  let startX;
  let scrollLeft;

  // Events for dragging navigation
  navListElement.addEventListener('mousedown', e => {
    isDown = true;
    startX = e.pageX - navListElement.offsetLeft;
    // eslint-disable-next-line prefer-destructuring
    scrollLeft = navListElement.scrollLeft;
  }, {
    passive: true
  });
  navListElement.addEventListener('mouseleave', () => {
    isDown = false;
    navListElement.classList.remove('active');
  });
  navListElement.addEventListener('mousemove', e => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - navListElement.offsetLeft;
    const walk = (x - startX) * 1.1;
    if (Math.abs(startX - e.pageX) > 10) navListElement.classList.add('active');
    navListElement.scrollLeft = scrollLeft - walk;
  });
  navListElement.addEventListener('mouseup', () => {
    isDown = false;
    navListElement.classList.remove('active');
  });

  // Add router-link-active class to the initially active menu link on page load
  const headerMobileLinks = navListElement ? navListElement.querySelectorAll('.header_mobile__nav_link') : [];
  const activeRouterClass = 'router-link-active';
  headerMobileLinks.forEach(headerMobileLink => {
    const {
      linkName
    } = headerMobileLink.dataset;

    // Check if current path includes linkName
    if (linkName && window.location.pathname.includes(linkName)) {
      const linkRect = headerMobileLink.getBoundingClientRect();
      const navRect = navElement.getBoundingClientRect();

      // Check if link is not fully visible in navElement
      if (linkRect.left < navRect.left || linkRect.right > navRect.right) {
        const scrollOffset = headerMobileLink.offsetLeft - navListElement.offsetWidth / 2 + headerMobileLink.offsetWidth / 2;
        const maxScroll = navListElement.scrollWidth - navListElement.offsetWidth;

        // Scroll only if the active link is not already fully visible
        navListElement.scrollLeft = Math.max(0, Math.min(scrollOffset, maxScroll));
      }

      // Add active class if linkName matches current path
      headerMobileLink.classList.toggle(activeRouterClass);
    } else if (window.location.pathname.includes('/zabava')) {
      // If it is funzone, remove subnavigation
      navElement.classList.add('hidden');
    }
  });
});